import { RegionalSettingsWrapper } from "./regional-settings";

export default function RegionalSettingsPage() {
  return <RegionalSettingsWrapper />;
}
